import { useEffect, useState } from "react";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import WebhookProviderForm from "@/components/webhooks/WebhookProviderForm";
import { InboundWebhookProviderResponse } from "@/api/webhookProviders";

interface Props {
  isPanelOpenned: boolean;
  mode: 'create' | 'edit';
  existingProvider?: InboundWebhookProviderResponse;
  onPanelClosed?: () => void;
  onSave?: (provider: any) => void;
  onShowSuccess?: (message: string) => void;
  onShowWarnings?: (messages: string[]) => void;
}

const WebhookProviderPanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  const isEditMode = props.mode === 'edit';
  const headerText = isEditMode 
    ? `Edit Inbound Webhook Provider${props.existingProvider ? ` - ${props.existingProvider.Description}` : ''}`
    : "New Inbound Webhook Provider";

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  return (
    <>
      <RigthPanel
        header={headerText}
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={WebhookProviderForm}
        type={RigthPanelType.medium}
        childProps={{
          mode: props.mode,
          existingProvider: props.existingProvider,
          onClose: () => onClosePanel(),
          onSave: (provider: any) => {
            if (props.onSave) {
              props.onSave(provider);
            }
            onClosePanel();
          },
          onShowSuccess: props.onShowSuccess,
          onShowWarnings: props.onShowWarnings,
        }}
      ></RigthPanel>
    </>
  );
};

export default WebhookProviderPanel;
